import { FormSection } from './FormSection';
import { ProductCardsCtaStyle } from './ProductCardsCtaStyle';

export const ProductCardsSection = () => {
  return (
    <>
      <FormSection
        name="product_cards.card_size"
        title="Size"
        subtitle="How large product cards appear on desktop"
        helperText="Card size applies on desktop. Row counts are for typical desktop
            widths; smaller screens and windows show fewer cards automatically."
        options={[
          {
            label: 'Small (6 per row)',
            value: 'small',
          },
          {
            label: 'Medium (5 per row)',
            value: 'medium',
            defaultOption: true,
          },
          {
            label: 'Large (4 per row)',
            value: 'large',
          },
        ]}
      />
      <FormSection
        name="product_cards.card_border"
        title="Style"
        subtitle="Choose whether product cards have an outline"
        options={[
          {
            label: 'No border',
            value: false,
            defaultOption: true,
          },
          {
            label: 'Border',
            value: true,
          },
        ]}
      />
      <ProductCardsCtaStyle />
      <FormSection
        name="product_cards.hover"
        title="Hover effect"
        subtitle="What happens when shoppers hover over a card"
        helperText="Try it: hover over the card preview. Effects apply on desktop only."
        options={[
          {
            label: 'Soft shadow',
            value: 'shadow',
            defaultOption: true,
          },
          {
            label: 'Brand shadow',
            value: 'shadow_color',
          },
          {
            label: 'Image border',
            value: 'image_border',
          },
          {
            label: 'Image zoom',
            value: 'image_zoom',
          },
        ]}
      />
    </>
  );
};
